import HarleyEventStore from 'ahoy.js'

if (typeof window !== 'undefined' && window.HarleyEventStore === undefined) {
  window.HarleyEventStore = HarleyEventStore
}
